import { ROLE_LEVELS } from '../constants';

// Accounts created before the wizard shipped never land in it; they can still open it from the sidebar.
const WIZARD_START = new Date('2026-10-07T00:00:00Z');

export const WIZARD_STEPS = ['import', 'widget', 'install', 'upgrade'];

// useUser starts with a placeholder holding only the workspace id until /me arrives; deciding on it would
// treat every workspace as brand new
export function isWorkspaceLoaded(workspace) {
  return !!(workspace && workspace.role);
}

// Read from the workspace's own stats, so leaving the wizard halfway loses nothing
export function getSetupProgress(workspace) {
  const stats = (workspace && workspace.stats) || {};
  return {
    import: !!(stats.testimonials && stats.testimonials.firstCreated),
    widget: !!(stats.widgets && stats.widgets.firstCreated),
    install: !!(stats.widgets && stats.widgets.firstRequestFromWebsite),
  };
}

export function getFirstOpenStep(workspace) {
  const progress = getSetupProgress(workspace);
  return WIZARD_STEPS.find((step) => !progress[step]) || 'upgrade';
}

// A brand new workspace owner who has not done anything yet starts in the wizard instead of the testimonials page
export function shouldLandInWizard(user, workspace) {
  if(!user || !isWorkspaceLoaded(workspace) || !user.createdAt || new Date(user.createdAt) < WIZARD_START) {
    return false;
  }
  if(ROLE_LEVELS[workspace.role]?.level > ROLE_LEVELS.admin.level) {
    return false;
  }
  if(workspace.settings && workspace.settings.skipOnboarding) {
    return false;
  }
  const progress = getSetupProgress(workspace);
  return !progress.import && !progress.widget;
}
